import { Heading, Layout, RadioButton } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { getContractAnnuallyKms } from "../../data/contract";
import { useFormikContext } from "formik";
import { IMatchMakerAnswers } from "../../interfaces";
import { formatKmString } from "../../helpers/formatKmString";

export const AnnuallyKm = () => {
    const { t } = useTranslation(["question4page"]);
    const { values, setFieldValue } = useFormikContext<IMatchMakerAnswers>();
    return (
        <>
            <Heading level={2} className="u-font-size-fs2">{t("question4page:annually-kms.title")}</Heading>

            <Layout>
                {getContractAnnuallyKms().map((km) => (
                    <Layout.Item default="1/3" key={km}>
                        <RadioButton
                            name="kmsPerYear"
                            id={`AnnuallyKm_${km}`}
                            onChange={() => setFieldValue("kmsPerYear", km)}
                            checked={values["kmsPerYear"] === km}
                        >
                            {formatKmString(km)}
                        </RadioButton>
                    </Layout.Item>
                ))}
            </Layout>
        </>
    );
};
